import { ChangeDetectionStrategy, Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { InstructorStoreService } from '../../client/store/instructor.store.service';
import { DEFAULT_INSTRUCTOR_REVIEW_PAGE_OFFSET, DEFAULT_INSTRUCTOR_REVIEW_PAGE_SIZE } from '../../constants/pagination';
import { Instructor } from '../../models/instructor';
import { UserProfile } from '@modules/identity/models/user';
import { ClassroomCourse } from '@modules/course/classroom/models';
import { ClassroomCourseStoreService } from '@modules/course/classroom/store/services/classroom-course.store.service';
import { CountryStoreService } from '@shared/store/country-store/services/country.store.service';
import { IdentityStoreService } from '@modules/identity/store/services/identity-store.service';
import { AppStoreService } from '@core/store/app-store.service';
import { Country } from '@shared/models/country';
import { TRANSLATION_SCOPE } from '@modules/instructor/i18n/scope';
import { InstructorReviewFilter, Review } from '../../models/review';

@Component({
  selector: 'app-instructor-details',
  templateUrl: './instructor-details.component.html',
  styleUrls: ['./instructor-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstructorDetailsComponent implements OnInit, OnDestroy, OnChanges {
  public instructor$: Observable<Instructor>;
  public userInfo$: Observable<UserProfile>;
  public myClassroomCourses$: Observable<ClassroomCourse[]>;
  translationScope = TRANSLATION_SCOPE;
  instructorId: string;
  readMoreText = false;
  reviews$: Observable<Review[]>;
  totalLoadedInstructorReviews: number = 0;
  isAllInstructroReviewsLoaded: boolean = false;
  insturctorReviewFilters: InstructorReviewFilter = {
    pageOffset: DEFAULT_INSTRUCTOR_REVIEW_PAGE_OFFSET, pageSize: DEFAULT_INSTRUCTOR_REVIEW_PAGE_SIZE
  }
  private destroy$ = new Subject<void>();

  constructor(
    private instructorStoreService: InstructorStoreService,
    private classroomStore: ClassroomCourseStoreService,
    private route: ActivatedRoute,
    private countryStoreService: CountryStoreService,
    private appStore: AppStoreService,
    private identityStoreService: IdentityStoreService
  ) {
    //this.appStore.setDropdownResult(true);
    this.appStore.setColorChangeResult(true);
  }

  ngOnInit() {
    this.myClassroomCourses$ = this.classroomStore.getInstructorCourse();
    this.getUserInfo();
    const instructorId = this.route.snapshot.paramMap.get('id');
    this.instructorId = instructorId;
    if (instructorId) {
      this.fetchInstructorReviews();
      this.getInstructorReviews();
      this.getCurrentlyLoadedInstructorReviews();
      this.instructor$ = this.instructorStoreService.getInstructorById(instructorId).pipe(
        filter((instructor) => Boolean(instructor?.id)),
        map((instructor) => {
          this.readMoreText = Boolean(instructor?.description?.length > 254);
          instructor = { ...instructor, description: instructor.description.replace(/\n/g, '<br>') };
          return instructor;
        })
      );
      this.classroomStore.fetchInstructorCourse(instructorId);
    }
  }

  private getUserInfo() {
    this.userInfo$ = this.identityStoreService.getUserProfile();
  }

  public guideDefaultImage(guide: Instructor): string {
    const profilePicture = guide.medias.find((x) => x.default && x.category === 'profile');
    return profilePicture ? profilePicture.url : 'assets/images/user.png';
  }

  public getCountryName(twoLetterString: string): Observable<Country> {
    if (twoLetterString) {
      return this.countryStoreService.getCountryByCode(twoLetterString);
    }
    return null;
  }

  ngOnDestroy(): void {
    this.appStore.setDropdownResult(false);
    this.appStore.setColorChangeResult(false);
    this.instructorStoreService.removeInstructorReviews();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(): void {
  }


  readMore(): boolean {
    return (this.readMoreText = !this.readMoreText);
  }


  fetchMoreInstructorReviews(): void {
    this.insturctorReviewFilters = {
      pageOffset: this.insturctorReviewFilters.pageOffset + 1,
      pageSize: DEFAULT_INSTRUCTOR_REVIEW_PAGE_SIZE
    };
    this.fetchInstructorReviews();
  }

  private getInstructorReviews(): void {
    this.reviews$ = this.instructorStoreService.getInstructorReviews();
  }

  private getCurrentlyLoadedInstructorReviews(): void {
    this.instructorStoreService.getTotalLoadedInstructorReviews().pipe(
      takeUntil(this.destroy$)
    ).subscribe((totalLoadedReviews) => {
      this.totalLoadedInstructorReviews = totalLoadedReviews || 0;
    })
  }

  private fetchInstructorReviews(): void {
    this.instructorStoreService.fetchInstructorReviews(this.instructorId, this.insturctorReviewFilters);
  }

}
